import { z } from 'zod';

import { FeeId } from '../BrandedIds';
import { Payment } from '../loan/Payments';
import { zodBrandedUuid } from '../utils/Zod';
import { BaseLoanEvent } from './BaseLoanEvent';

export const CreateAdvancePaymentEvent = BaseLoanEvent.extend({
  type: z.literal('createAdvancePayment'),
  payment: Payment,
  advanceId: zodBrandedUuid<FeeId>(),
  disableEmail: z.boolean().optional(),
});
export type CreateAdvancePaymentEvent = z.infer<typeof CreateAdvancePaymentEvent>;
